import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unsupported',
  templateUrl: './unsupported.component.html',
  styleUrls: ['./unsupported.component.css']
})
export class UnsupportedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
